var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-select',{attrs:{"options":_vm.productsOpt,"size":"sm"},on:{"change":_vm.change},model:{value:(_vm.provinceProduct.tariffa_codice),callback:function ($$v) {_vm.$set(_vm.provinceProduct, "tariffa_codice", $$v)},expression:"provinceProduct.tariffa_codice"}})
}
var staticRenderFns = []

export { render, staticRenderFns }